export const DATE_INPUT_ERRORS = {
  INVALID_DATE: 'dateInput.invalidDate',
};
